<template lang="pug">
section#sidebar
  Menu#sb-main-menu(k="main-menu" toggle-event="click")
</template>

<script>
import Menu from '@/components/Menu';

export default {
  name: 'Sidebar',
  components: {
    Menu
  },
  mounted() {
    this.$emit('mounted');
  }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

section#sidebar
  @apply py-6 overflow-auto
  color: var(--color-link-sidebar-menu)
  background-color: var(--color-primary)
  nav
    ::v-deep
      a
        @apply no-underline
      ul.tree-menu
        li
          & > ul
            &.tree-menu
              margin-left: 1.375rem
              a
                @apply font-normal
          a
            @apply block text-lg font-medium px-6 py-2
            & > button
              @apply border-0 float-right text-right
              background-color: transparent
              text-color: var(--color-base-text)
              outline: none
              font-size: 1.1rem
              width: 2.5rem
            &:hover
              color: var(--color-link-hover-sidebar-menu)
            &:focus,
            &:active
              color: var(--color-link-hover-sidebar-menu)
          .tree-item
            @apply flex
            & > a
              @apply flex-grow
            
        .show-enter-active, .show-leave-active
          @apply overflow-hidden
          transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease
          transform-origin: left center
          max-height: 31.25rem
        .show-enter, .show-leave-to
          @apply opacity-0
          max-height: 0
          transform: translateX(-0.938rem)
  nav + nav
    @apply relative mt-8
    &:before
      @apply absolute
      content: ''
      height: 0.25rem
      top: calc(-1rem - 0.125rem)
      left: calc(50% - 3.125rem)
      width: 6.25rem
      background: #35373b
      border-radius: 0.25rem
</style>
